// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24030","rootMobile":"styles_rootMobile__2dwD4"};